/**
 * Sleeper cache refresh — one entry point that re-pulls everything the
 * Home screen shows from Sleeper (league list + per-league draft
 * glances). Used by pull-to-refresh and by the app-resume hook, so a
 * league you just joined appears without relinking or restarting.
 */
import { queryClient } from '@/lib/queryClient';

const SLEEPER_KEYS = new Set(['sleeper-leagues', 'league-glances']);

export function refreshSleeperData(): Promise<unknown> {
  return queryClient.invalidateQueries({
    predicate: (q) => SLEEPER_KEYS.has(String(q.queryKey[0])),
  });
}

/**
 * Re-pull on app resume (foregrounding after Sleeper's app, e.g. right
 * after accepting a league invite). Native shell only; safe no-op on web.
 */
export function installSleeperResumeRefresh(): void {
  try {
    const app = (
      window as unknown as {
        Capacitor?: {
          isNativePlatform?: () => boolean;
          Plugins?: {
            App?: {
              addListener: (ev: string, cb: () => void) => unknown;
            };
          };
        };
      }
    ).Capacitor;
    if (!app?.isNativePlatform?.()) return;
    app.Plugins?.App?.addListener('resume', () => {
      void refreshSleeperData();
    });
  } catch {
    /* resume refresh just won't happen */
  }
}
